import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigationType } from 'react-router-dom';
import ProjectPage from './components/ProjectPage';
import './App.css';
import { Analytics } from "@vercel/analytics/react"
import Navbar from './components/Navbar'
import Contact from "./components/Contact";
import About from "./components/About";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTopOnNavigation() {
  const { pathname } = useLocation();

  useEffect(() => {
    smoothScrollToTop();
  }, [pathname]);

  return null;
}

function smoothScrollToTop() {
  const duration = 600; // ms
  const start = document.body.scrollTop || document.documentElement.scrollTop;
  const startTime = performance.now();

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animate(time) {
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeOutCubic(progress);

    document.documentElement.scrollTop = start * (1 - ease);
    document.body.scrollTop = start * (1 - ease);

    if (progress < 1) requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
}



const projects = [
  {
    id: 'puzzlemove',
    title: 'Level Designs: 6 Years of Experience with Angry Birds',
    tags: ['Game & Level Design'],
    images: ['/images/angry-birds.jpg'],
    link: '',
    description: `Compilation showcasing my +6 years of professional experience as a game level designer and tester.`
  },
  {
    id: 'frog',
    title: 'The Jogger Frog: AR Previsualization Project',
    tags: ['Extended Reality', 'Previsualization'],
    images: ['/images/frog.png'],
    video: '/images/frog-wave.mp4',
    link: '',
    description: 'Meet your new AR fitness coach who motivates you to move. Spoilers, he is a frog!',
  },
  {
    id: 'gardenia',
    title: 'Gardenia: AR Gardening Game',
    tags: ['Game & Level Design', 'Extended Reality'],
    images: ['/images/gardenia.jpg'],
    link: 'https://drive.google.com/file/d/1PqUsF3OP8mYoQ3nxj2Vm4HLPrubLYX36/view?usp=sharing',
    description: 'An AR garden game where players control the growth of flowers by tangible interactions, creating an immersive experience.',
  },
  {
    id: 'consciously',
    title: 'Consciously: Mindful Shopping Experience',
    tags: ['User Experience', 'UI Design'],
    selected: true,
    images: ['/images/ss2.png'],

    video: '/images/mock-video.mp4',
    link: '',
    description: 'Started as a mobile app, turned into a browser extension design to prevent impulsive shopping and develop mindful shopping skills.',
  },
  {
    id: 'borderless-whiteboard',
    title: 'Borderless: A Unified Design Collaboration Platform',
    tags: ['User Experience'],
    images: ['/images/border.png'],
    link: 'https://drive.google.com/file/d/1G0ndMS0AgFpH3K2u6JLcf9fqUa0IwP5i/view?usp=sharing',
    description: 'A collaborative whiteboard tool design with 3 innovative features: Layered workspaces, enhanced collaborative tools and version control support.',
  },
  {
    id: 'aura-palette',
    title: 'Aura Palette: Design System Case Study',
    tags: ['Design System','UI Design','User Experience', 'Front-end Development'],    
    selected: true,
    images: ['/images/auramock.png'],
    link: 'https://aura-palette.vercel.app/',
    description: 'A color palette generator with machine learning algorithms based on mood and context.',
  },
  {
    id: 'goodreads-study',
    title: 'GoodReads Usability Case Study',
    tags: ['User Experience', 'User Research', 'Quantitative Data'],
    selected: true,
    images: ['/images/goodreads.png'],
    link: 'https://quantux.telecom-paris.fr/2025/03/07/evaluating-the-usability-of-goodreads/',
    description: 'A data-focused use case study of Goodreads. Identifying key friction points through a UX protocol with 16 participants.',
  },
  {
    id: 'fridge-it',
    title: 'Fridge-It!: Designing a Sustainable Food Sharing System',
    tags: ['User Experience', 'Design Sprint'],
    images: ['/images/fridge3.png'],
    link: '',
    description: 'A UX sprint to design a hybrid system combining physical labels and an app to reduce food waste.',
  },
  // ACADEMIC RESEARCH
  {
    id: 'code-smells',
    title: 'Journal Paper: A Taxonomy Towards Inline Code Comment Smells',
    tags: ['Academic Research'],
    images: ['/images/taxonomy.png'],
    link: 'https://link.springer.com/article/10.1007/s10664-023-10425-5',
    description: '2nd author of the journal paper published in Empirical Software Engineering.',
  },
  {
    id: 'personality perception',
    title: 'Conference Paper: Personality Perception in Human Videos Altered by Motion Transfer Networks',
    tags: ['Academic Research'],
    images: ['/images/personality-paper.png'],
    link: 'https://arxiv.org/abs/2401.14733',
    description: '1st author of the conference paper published in Computer & Graphics.',
  },
  {
    id: 'match3',
    title: 'Extensive Analysis of Four Popular Match-3 Games',
    tags: ['Game & Level Design', 'Case Study'],
    images: ['/images/match.png'],
    link: '',
    description: `My analysis of four match-3 games (Royal Match, Toon Blast, Candy Crush, Gardenscapes) based on game mechanics, level design, level difficulty, graphics, animation, particles & special effects, and user interface.`,
  },
  {
    id: 'macrame-data',
    title: 'Exploring Expressivity of Macramé in Data Physicalization',
    tags: ['Data Physicalization', 'Academic Research'],
    images: ['/images/macrame.png'],
    link: 'https://arxiv.org/abs/2401.14733',
    description: "A cross-disciplinary workshop series exploring macramé as a medium for data physicalization, where I led the protocol design and co-authored the research paper on findings.",
    },
  /*{
    id: 'starcraft-ai',
    title: 'Starcraft AI Bot Design for Zerg Race',
    tags: ['Game & Level Design'],
    images: ['/images/starcraft3.png'],
    link: '',
    description: 'A real-time AI bot for Zerg race in Starcraft using behavior trees and blackboard architecture.',
  },
  {
    id: 'echonos',
    title: 'Echonos: Game Design with CBT Methods for Social Anxiety',
    tags: ['Game & Level Design'],
    images: ['/images/echonos.png'],
    link: 'https://drive.google.com/file/d/1CVmKLZB8k2vroIGE5LEznjeIbIS9NyZM/view?usp=sharing',
    description: 'A visual novel game design for adults with Social Anxiety Disorder, integrating cognitive behavioral therapy.',
  },*/
  // DATA VIZ
  {
    id: 'data-catcher',
    title: 'Data Catcher: Physicalizing Sleep Data',
    tags: ['Data Physicalization'], 
    images: ['/images/catcher.png'],
    link: '',
    description: "A dreamcatcher-inspired physicalization of my sleep and dream data, designed to explore patterns and improve sleep habits."
  },
  {
    id: 'paintings',
    title: 'Series of Paintings',
    tags: ['Paintings'],
    images: ['/images/painting-cover.png'],
    link: '',
    description: 'A small collection of my paintings created over the past few years, inspired by nature, animals and vibrant color palettes. I love experimenting with oils, pastels, and watercolor to create art that makes my inner child happy.',
  }
/* {
    id: 'soul-dragon-knight',
    title: 'Soul Dragon Knight – Multiplayer Game',
    tags: ['Game & Level Design'],
    images: ['/images/soul-dragon.png'],
    link: '',
    description: 'Unity-based fantasy game built in a 6-person team. Designed levels and created pixel art assets.',
  },*/

  // PAINTING
  /*
  {
    id: 'digital-paintings',
    title: 'Series of Digital Paintings',
    tags: ['Paintings'],
    images: ['https://i.imgur.com/GI6ix2n.png'],
    link: '',
    description: '-',
  },*/
  // COMPUTER GRAPHICS
  /*
  {
    id: '2d-paint-application',
    title: 'Soul Dragon Knight – Multiplayer Game',
    tags: ['Level Design', 'Game Design'],
    images: ['https://i.imgur.com/GI6ix2n.png'],
    link: '',
    description: 'Unity-based fantasy game built in a 6-person team. Designed levels and created pixel art assets.',
  },
  {
    id: 'mesh-simplification-algorithm',
    title: 'Soul Dragon Knight – Multiplayer Game',
    tags: ['Level Design', 'Game Design'],
    images: ['https://i.imgur.com/GI6ix2n.png'],
    link: '',
    description: 'Unity-based fantasy game built in a 6-person team. Designed levels and created pixel art assets.',
  },
  {
    id: 'centaur-animation',
    title: 'Soul Dragon Knight – Multiplayer Game',
    tags: ['Level Design', 'Game Design'],
    images: ['https://i.imgur.com/GI6ix2n.png'],
    link: '',
    description: 'Unity-based fantasy game built in a 6-person team. Designed levels and created pixel art assets.',
  },*/
];

const allTags = [
  'User Experience',
  //'UX Design', 
  //'UX Research', 
  'Game & Level Design',
  //'Academic Research', 
  //'Data Physicalization',
  'Extended Reality',
  //'Software Development', 
  'Paintings'
];

function App() {
  const [selectedTag, setSelectedTag] = useState('Selected');

  const filteredProjects =
    selectedTag === 'All'
      ? projects
      : selectedTag === 'Selected'
      ? projects.filter(p => p.selected)
      : projects.filter(p => p.tags.includes(selectedTag));

  return (
  <Router>
  <Navbar />
  <Analytics />
  <ScrollToTopOnNavigation />
  <Routes>
    <Route
      path="/"
      element={
        <div className="fade-in container">
        <div className="about-photo">
          <img src="/images/profile.png" />
        </div>
          <h1 className="title">Ayda Yurtoğlu</h1>

          <p className="bio">
            Engineer turned designer, passionate about crafting human-centered experiences,<br/>
            and exploring the intersection of UX, design, and play.
          </p>

          <div className="top-buttons">
            <a
              href="https://cvdesignr.com/p/691c3cd4ee656"
              target="_blank"
              rel="noreferrer"
            >
              <button className="cv-button">CV</button>
            </a>
            <a href="https://linkedin.com/in/aydayurtoglu" target="_blank" rel="noreferrer">
              <img src="https://img.icons8.com/ios-filled/30/58404E/linkedin.png" alt="LinkedIn" />
            </a>
            <a href="https://github.com/aydayurtoglu" target="_blank" rel="noreferrer">
              <img src="https://img.icons8.com/ios-filled/30/58404E/github.png" alt="GitHub" />
            </a>
            <a href="mailto:aydayurtoglu@gmail.com">
              <img src="https://img.icons8.com/ios-filled/30/58404E/new-post.png" alt="Email" />
            </a>
          </div>

          
          <div className="filter-buttons">
            <button
              className={selectedTag === 'Selected' ? 'active' : ''}
              onClick={() => setSelectedTag('Selected')}
            >
              ✦ Selected Works
            </button>
            <button
              className={selectedTag === 'All' ? 'active' : ''}
              onClick={() => setSelectedTag('All')}
            >
              All Projects
            </button>
            {allTags.map((tag) => (
              <button
                key={tag}
                className={selectedTag === tag ? 'active' : ''}
                onClick={() => setSelectedTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>

          <div className="project-container">
            <ul className="project-list">
              {filteredProjects.map((project, index) => (
                <li key={index} className="project-card">
                  <div className="project-content">
                    <Link to={`/project/${project.id}`}>
                      <Link to={`/project/${project.id}`}>
                      {project.video ? (
                        <video
                          src={project.video}
                          className="thumbnail-side"
                          autoPlay
                          loop
                          muted
                          playsInline
                        />
                      ) : (
                        <img
                          src={project.images[0]}
                          alt={project.title}
                          className="thumbnail-side"
                        />
                      )}
                    </Link>

                    </Link>
                    <div className="project-info-title">
                      <h3>
                        <Link to={`/project/${project.id}`}>{project.title}</Link>
                      </h3>
                      <div className="tag-row">
                        {project.tags.map((tag, i) => (
                          <span key={i} className="tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <p className="description">{project.description}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      }
    />
    <Route path="/project/:id" element={<ProjectPage projects={projects} />} /> 
    <Route path="/contact" element={<Contact />} />
    <Route path="/about" element={<About />} />
     
  </Routes>
</Router>

  );
}

export default App;
